module.exports = __webpack_public_path__ + "img/87c369f.png";